<div class="order-price-details-view">
  <div class="item flex flex__align-items--center"
      *ngFor="let item of items">
    <ng-container *ngIf="item.model">
      <mat-icon *ngIf="item.config.withIcon" class="custom-icons" [svgIcon]="item.config.icon"></mat-icon>
      <app-component-resolver
          [ngClass]="item.config.classes"
          [data]="item.model"
          [config]="item.config.componentConfig">
      </app-component-resolver>
    </ng-container>
  </div>
</div>